import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

import { httpGet } from '../../../../components/utils';
import { useEffect, useState } from 'react';
import { HttpResponse } from '../../../../api/types/Http';
import { InsightReason } from '../types/InsightReason';

interface Params {
    entityGuid: string;
    riskRule: string;
    entityName: string;
    shouldFetch: boolean;
}

const useGetThreatReason = ({ entityGuid, riskRule, entityName, shouldFetch }: Params) => {
    const [data, setData] = useState<InsightReason>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const getThreatReason = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet(`/insights/threatReasons/${entityGuid}`, {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: {
                            riskType: riskRule,
                            entityName
                        }
                    }
                })) as unknown as HttpResponse<InsightReason>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get shadow admin reasons');
            }

            setIsFetching(false);
        };

        if (shouldFetch) {
            getThreatReason();
        }
    }, [entityGuid, shouldFetch]);

    return { data, isFetching, error };
};

export default useGetThreatReason;
